

export const destinationLabel = (index: number, arrayCount: number) => {
  if (arrayCount === index) return "Dirección final";
  else if (arrayCount > 1) return `Parada ${index}`;

  return "Dirección final";
};